import { useMemo } from 'react';
import { useSelector } from 'react-redux';


export function useThemeCustomStyles() {
    const { clienteActivo, estilosDeCliente } = useSelector((state) => state.theme);
    const styles = useMemo(() => {
      const clientThemeConfig = estilosDeCliente[clienteActivo] || estilosDeCliente.cliente1;
  
      return {
        //...clientThemeConfig.customStyles[`${key}`],
        ...clientThemeConfig.customStyles,
      };
    }, [clienteActivo, estilosDeCliente]);
  
    return styles;
  }

export function useThemeStatics() {
    const { clienteActivo, estilosDeCliente } = useSelector((state) => state.theme);
    const styles = useMemo(() => {
      const clientThemeConfig = estilosDeCliente[clienteActivo] || estilosDeCliente.cliente1;
  
      return {
        //...clientThemeConfig.customStyles[`${key}`],
        ...clientThemeConfig.static,
      };
    }, [clienteActivo, estilosDeCliente]);
  
    return styles;
  }

export default function useThemeConfig() {
  const { clienteActivo, estilosDeCliente } = useSelector((state) => state.theme);
  const themeConfig = useMemo(() => {
    const clientThemeConfig = estilosDeCliente[clienteActivo] || estilosDeCliente.cliente1;

    return {
      palette: clientThemeConfig.palette,
      typography: clientThemeConfig.typography,
      components: {
        ...clientThemeConfig.muiStyleOverrides,

      },
    };
  }, [clienteActivo, estilosDeCliente]);

  return themeConfig;
}